import React, {useEffect} from 'react';
import Main from './floatingInventory';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import '../styles.scss';
import {useSearchParams} from 'react-router-dom';

const FloatingInventory = (props) => {
  const [searchParams] = useSearchParams();
  const filters = {
    'group': searchParams.get('group'),
    'master': searchParams.get('master'),
    'sfx': searchParams.get('sfx'),
    'dealer': searchParams.get('dealer'),
    'reservationAdvance': searchParams.get('reservationAdvance'),
    'antiquity': searchParams.get('antiquity'),
  };
  useEffect(() => {
    props.fetchFloatingInventory(filters, props.isUserTde ? 'S' : 'N');
    props.fetchDealers('float');
    props.fetchExemptionManagementList();
    props.fetchProvinceTypes();
    props.fetchCitiesCodes();
    props.fetchClientTypes();
    props.fetchContributorTypes();
  }, []);

  return <Main filters={filters} />;
};
const {
  fetchDealers,
  fetchExemptionManagementList,
  fetchFloatingInventory,
  fetchProvinceTypes,
  fetchCitiesCodes,
  fetchClientTypes,
  fetchContributorTypes,
  navigateTo,
  setCurrentFlUserGroup,
} = Actions;

const mapStateToProps = (state) => {
  return {
    'isUserTde': state.session.isUserFromTDE,
    'permissions': state.session.permissions,
    'dealerId': state.session.dealerId,
  };
};

export default connect(mapStateToProps, {
  fetchDealers,
  fetchExemptionManagementList,
  fetchFloatingInventory,
  fetchProvinceTypes,
  fetchCitiesCodes,
  fetchClientTypes,
  fetchContributorTypes,
  navigateTo,
  setCurrentFlUserGroup,
})(FloatingInventory);
